import { useSearchParams as _useSearchParams } from 'react-router-dom';

export function useSearchParams() {
  const [searchParams, setSearchParams] = _useSearchParams();
  return [searchParams, setSearchParams];
}